import {
    FETCH_SEMESTER_REQUEST,
    FETCH_SEMESTER_SUCCESS,
    FETCH_SEMESTER_FAILURE,
    SET_CURRENT_SEMESTER,
    CLEAR_SEMESTER
} from './types';
import axios from 'axios';
import { URL } from '../../config';

// Action creators
export const fetchSemesterRequest = () => ({
    type: FETCH_SEMESTER_REQUEST
});

export const fetchSemesterSuccess = (semester) => ({
    type: FETCH_SEMESTER_SUCCESS,
    payload: semester
});

export const fetchSemesterFailure = (error) => ({
    type: FETCH_SEMESTER_FAILURE,
    payload: error
});

export const setCurrentSemester = (semester) => ({
    type: SET_CURRENT_SEMESTER,
    payload: semester
});

export const clearSemester = () => ({
    type: CLEAR_SEMESTER
});

// Thunk action to fetch current semester
export const fetchCurrentSemester = () => {
    return async (dispatch) => {
        dispatch(fetchSemesterRequest());

        try {
            const response = await axios.get(`${URL}/semesters/current`);
            const semester = response.data;
            dispatch(fetchSemesterSuccess(semester));
            return semester;
        } catch (error) {
            const serverError = error?.response?.data?.error || error?.message || 'Failed to fetch current semester.';
            dispatch(fetchSemesterFailure(serverError));

            console.error('Error fetching current semester:', error);
            throw error;
        }
    };
};
